<template>
  <div>
    <vue-topprogress ref="loadingProgress"></vue-topprogress>
    <div class="animated fade-in" v-if="!loading">

      <h1 class="display-4 font-weight-lighter">Product Documents</h1>

      <b-tabs>

        <b-tab title="Images">

          <b-tabs class="pt-2" lazy>
            <template v-for="(type, type_index) in product_types">
              <b-tab v-if="type.product_categories && type.product_categories.length" :key="'type_'+type_index" :title="type.full_name">
                <b-tabs class="pt-2" lazy>
                  <b-tab v-for="(category, category_index) in type.product_categories" :key="'category_'+category_index" :title="category.name" class="pt-3">
                    <product-image-table v-if="category.products" :products="category.products"></product-image-table>
                  </b-tab>
                </b-tabs>
              </b-tab>
            </template>
          </b-tabs>

<!--          <div v-for="(type, type_index) in product_types" :key="'type_'+type_index">-->
<!--            <h3 class="font-weight-bold mt-4 mb-3">{{ type.full_name }}</h3>-->
<!--            <div v-for="(category, category_index) in type.product_categories" :key="'category_'+category_index">-->
<!--              <h4 class="font-weight-bold mt-4 mb-3 text-muted">{{ category.name }}</h4>-->
<!--              <product-image-table v-if="category.products" :products="category.products"></product-image-table>-->
<!--            </div>-->
<!--          </div>-->
        </b-tab>

        <b-tab title="Specs">

          <b-tabs class="pt-2" lazy>
            <template v-for="(type, type_index) in product_types">
              <b-tab v-if="type.product_categories && type.product_categories.length" :key="'type_'+type_index" :title="type.full_name">
                <b-tabs class="pt-2" lazy>
                  <b-tab v-for="(category, category_index) in type.product_categories" :key="'category_'+category_index" :title="category.name" class="pt-3">
                    <product-spec-table v-if="category.products" :products="category.products"></product-spec-table>
                  </b-tab>
                </b-tabs>
              </b-tab>
            </template>
          </b-tabs>

<!--          <div v-for="(type, type_index) in product_types" :key="'type_'+type_index">-->
<!--            <h3 class="font-weight-bold mt-4 mb-3">{{ type.full_name }}</h3>-->
<!--            <div v-for="(category, category_index) in type.product_categories" :key="'category_'+category_index">-->
<!--              <h4 class="font-weight-bold mt-4 mb-3 text-muted">{{ category.name }}</h4>-->
<!--              <product-spec-table v-if="category.products" :products="category.products"></product-spec-table>-->
<!--            </div>-->
<!--          </div>-->
        </b-tab>

      </b-tabs>

    </div>
  </div>
</template>

<script>

  import ProductImageTable from "../../components/products/ProductImageTable";
  import ProductType from "../../models/ProductType";
  import Product from "../../models/Product";
  import {GREEDY_FETCH_ENTITY} from "@/store/action-types";
  import ProductCategory from "../../models/ProductCategory";
  import ProductSpecTable from "../../components/products/ProductSpecTable";

  export default {
  name: "ProductDocuments",
  components: {ProductSpecTable, ProductImageTable},
  data() {
    return {
      loading: true,
      product_types: null,
      // products: []
    };
  },
  methods: {
    populate() {
      this.product_types = ProductType.query().with([
        'product_categories.products.images',
        'product_categories.products.specifications',
      ]).get();
      // this.product_types.forEach((type) => {
      //   this.products[type.id] = Product.query().where('product_type_id', type.id).with('images').get();
      // });
    },
    fetch() {
      return Promise.all([
        this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: ProductType}),
        this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: ProductCategory}),
        this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Product}),
        //Product.api().fetch({limit: 9999}),
        //ProductType.api().fetch({limit: 9999}),
      ]);
    },
    init() {
      this.$refs.loadingProgress.start();
      this.loading = true;
      this.fetch().then(() => {
        this.populate();
        this.loading = false;
        this.$refs.loadingProgress.done();
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
